// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__NwdpZ","errorLogs":"EditorFooter_errorLogs__1iWj6"};